module.exports = __webpack_public_path__ + "img/win_5.d3e25e09.png";